import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin-left":"20px"} }, "客户列表", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"20px","line-height":"40px"} }, " 客户名: ", -1 /* HOISTED */)
const _hoisted_4 = { style: {"margin-left":"20px"} }
const _hoisted_5 = { style: {"margin-left":"20px"} }
const _hoisted_6 = { style: {"margin-left":"20px"} }
const _hoisted_7 = { style: {"margin-left":"10px"} }
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = { style: {"text-align":"center","margin-top":"30px"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","padding-left":"60px"} }, "*新创建的账号需使用账户名和初始密码（12345a）进行首次登录", -1 /* HOISTED */)
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_has = _resolveDirective("has")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              placeholder: "请输入客户名",
              maxlength: "10",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              class: "input-with-select"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _ctx.loadData
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
              [_directive_has, void 0, "CustomerList"]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 创建客户")
              ]),
              _: 1 /* STABLE */
            })), [
              [_directive_has, void 0, "AddCustomer"]
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.customerList,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "序号",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString((_ctx.page - 1) * 10 + scope.$index + 1), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "userAccount",
                label: "客户账号",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "客户名",
                width: "300"
              }),
              _createVNode(_component_el_table_column, {
                prop: "code",
                label: "客户编码",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "phoneNo",
                label: "手机号码",
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(`+${scope.row.phoneNo}`), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "状态",
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.statusFormat(scope.row.status)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_table_column, {
                prop: "serviceCodeName",
                label: "资源地区",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "remark",
                label: "备注"
              }),
              _createVNode(_component_el_table_column, {
                prop: "updatedBy",
                label: "操作人",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "200"
              }, {
                default: _withCtx((scope) => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "text",
                    size: "small",
                    onClick: ($event: any) => (_ctx.opendetail(scope.row.customerId))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                    [_directive_has, void 0, "CustomerQuery"]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "text",
                    size: "small",
                    onClick: ($event: any) => (_ctx.reSetPass(scope.row.userAccountId))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置密码")
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                    [_directive_has, void 0, "ResetUserInfoPassword"]
                  ]),
                  _createCommentVNode(" <el-button type=\"text\" size=\"small\" @click=\"del(scope.row.customerId,scope.row.name)\" v-has:DeleteCustomer>删除</el-button> ")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["data"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              total: _ctx.total,
              onCurrentChange: _ctx.pageChange
            }, null, 8 /* PROPS */, ["total", "onCurrentChange"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_el_dialog, {
      title: "创建客户",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveCustomer()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("确 定")
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "createform",
          model: _ctx.createCustomer,
          rules: _ctx.rules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "客户编码",
              prop: "code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  maxlength: "5",
                  modelValue: _ctx.createCustomer.code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createCustomer.code) = $event)),
                  placeholder: "请输入客户编码",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "客户账号",
              prop: "userAccount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  maxlength: "20",
                  minlength: "5",
                  modelValue: _ctx.createCustomer.userAccount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createCustomer.userAccount) = $event)),
                  placeholder: "请输入客户账号",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "客户名",
              prop: "name",
              error: _ctx.nameError
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: "10",
                  minlength: "1",
                  type: "text",
                  modelValue: _ctx.createCustomer.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createCustomer.name) = $event)),
                  placeholder: "请输入客户名",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["error"]),
            _createVNode(_component_el_form_item, {
              label: "联系人",
              prop: "contacts"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  maxlength: "10",
                  modelValue: _ctx.createCustomer.contacts,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createCustomer.contacts) = $event)),
                  placeholder: "请输入联系人",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "phoneNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.createCustomer.phoneNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.createCustomer.phoneNo) = $event)),
                  autocomplete: "off",
                  maxlength: "11",
                  minlength: "6",
                  placeholder: "请输入手机号码"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.createCustomer.phonePrefix,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createCustomer.phonePrefix) = $event)),
                      style: {"width":"100px"},
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryAreaCodes, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "地址",
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  maxlength: "30",
                  modelValue: _ctx.createCustomer.address,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createCustomer.address) = $event)),
                  placeholder: "请输入地址",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "资源地区",
              prop: "serviceCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.createCustomer.serviceCode,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createCustomer.serviceCode) = $event)),
                  placeholder: "请选择资源地区"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.serviceCode,
                        label: item.description,
                        value: item.serviceCode
                      }, null, 8 /* PROPS */, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "角色",
              prop: "accessGroupId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.createCustomer.accessGroupId,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createCustomer.accessGroupId) = $event)),
                  placeholder: "请选择角色"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessGroup, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8 /* PROPS */, ["label", "value"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  maxlength: "50",
                  modelValue: _ctx.createCustomer.remark,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.createCustomer.remark) = $event)),
                  placeholder: "请输入备注",
                  autocomplete: "off"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _hoisted_10
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model", "rules"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}